/* NOS LARGE BAR: セール期間中だけバーを出し、終了までの日数を出す（日本時間で判定） */
(function () {
  var JST = 9 * 3600 * 1000;
  function day(ms) { return Math.floor((ms + JST) / 86400000); }
  function run() {
    var now = Date.now();
    document.querySelectorAll('.nos-lbar').forEach(function (el) {
      var s = Date.parse(el.getAttribute('data-start')), e = Date.parse(el.getAttribute('data-end'));
      var on = !isNaN(s) && !isNaN(e) && now >= s && now <= e;
      el.hidden = !on;
      var chip = el.querySelector('[data-nos-lbar-left]');
      if (chip && on) { var left = day(e) - day(now); chip.textContent = left <= 0 ? '本日まで' : 'あと' + left + '日'; }
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
  setInterval(run, 60000);
})();
